var _circle, _circle2, _path, _circle3, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0A7CC1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.832,
    cy: 22.167,
    r: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 16.5C16.0546 16.5 18.6668 19.1115 18.667 22.333L18.6592 22.6338C18.5028 25.7158 15.9539 28.167 12.833 28.167L12.5332 28.1592C9.45102 28.003 7 25.454 7 22.333C7.00018 19.1116 9.6116 16.5002 12.833 16.5ZM12.833 18C10.44 18.0002 8.50018 19.94 8.5 22.333C8.5 24.7261 10.4399 26.6668 12.833 26.667C15.2262 26.667 17.167 24.7262 17.167 22.333C17.1668 19.9399 15.2261 18 12.833 18Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 29.332 20.667)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.835 16.5C24.6134 16.5 22.0012 19.1115 22.001 22.333L22.0088 22.6338C22.1652 25.7158 24.7141 28.167 27.835 28.167L28.1348 28.1592C31.217 28.003 33.668 25.454 33.668 22.333C33.6678 19.1116 31.0564 16.5002 27.835 16.5ZM27.835 18C30.2279 18.0002 32.1678 19.94 32.168 22.333C32.168 24.7261 30.228 26.6668 27.835 26.667C25.4417 26.667 23.501 24.7262 23.501 22.333C23.5012 19.9399 25.4418 18 27.835 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 22.334L22.0013 22.334",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83203 14.3965H32.832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFit);
export default __webpack_public_path__ + "static/media/fit.062f766049cbb802ffa0c9f7d7fa5108.svg";
export { ForwardRef as ReactComponent };